import { render, staticRenderFns } from "./TestItemAudio.vue?vue&type=template&id=667cdb05&"
import script from "./TestItemAudio.vue?vue&type=script&lang=js&"
export * from "./TestItemAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports